import { singleQuotePlaceholder } from '../variables.ts'

export const functionToString = fn =>
  fn.toString().replace(/'/g, singleQuotePlaceholder)

export const functionFromString = fnString =>
  // eslint-disable-next-line
  Function(
    `return (${fnString.replace(
      new RegExp(singleQuotePlaceholder, 'g'),
      "'"
    )})();`
  )
